<template>
    <div class="bg-white" style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <br />
            <CRow class="header-row mb-3 position-relative">
                <!-- Back Button on the Left -->
                <CCol class="col-auto">
                    <CButton class="back-button" @click="$router.go(-1)">
                        ←
                    </CButton>
    
                </CCol>
    
                <!-- Centered Title -->
                <CCol class="d-flex justify-content-center position-absolute start-50 translate-middle-x">
                    <h3 class="section-title m-0" v-for="item in detailIndustries.slice(0,1)" :v-bind:key="item.Id"> {{ item.category }}</h3>
                </CCol>
            </CRow>
            <div class="w-100 mt-5">
                <br />
                <CContainer>
                    <div v-if="detailIndustries.length > 0">
                                            <CCard 
                            v-for="item in detailIndustries" 
                            :key="item.Id" 
                            class="custom-border-white p-3 rounded-3 shadow-sm" 
                            @click="GoToReview(item.companyId)"
                        >
                            <CRow class="align-items-center p-2">
                                <!-- Left: Company Logo -->
                                <CCol xs="4" class="d-flex justify-content-center">
                                    <img :src="item.profilePhoto" width="70px" />
                                </CCol>

                                <!-- Right: Details -->
                                <CCol xs="8" class="ml-3">
                                    <div class="d-flex justify-content-between align-items-center w-100">
                                        <div class="absolute right-2 flex items-center space-x-1 bg-purple-600 rounded-lg">
                                            <img src="../assets/img/new/smallicon/dot.png" width="8px" class="relative" />
                                            <span class="custom-12px-500 text-muted ml-2"> {{ item.category }}</span>
                                            <span class="text-white text-xs font-bold position-right mr-3">
                                                <img src="../assets/img/new/Bookmark.png" width="20px" class="me-1" />
                                            </span>
                                        </div>
                                    </div>
                                    <h5 class="custom-16px-500 mt-1 font-color-171717">{{ item.companyName }}</h5>
                                    <CButton type="button" class="custom-light-purple px-3 py-1 font-color-928AFD mt-2">
                                        {{ item.countVoucher }} voucher available
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCard>
                    </div>
                    <!-- Show "No Data Available" when API returns an invalid response -->
                    <div v-else class="text-center p-4">
                        <p class="text-muted">No vouchers available for this industry.</p>
                    </div>
    
                    <br /><br />
                </CContainer>
                <Footerlayout />
            </div>
        </CContainer>
    
    </div>
</template>


<script>
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";

export default {
    components: {
        Mainlayout,
        Footerlayout,
    },
    data() {
        return {
            industriesId: this.$route.query.id,
            detailIndustries: []
        };
    },
    mounted() {
        this.GetDetailIndustries();

    },
    methods: {
        goBack() {
            this.$router.push("Home"); // Navigate to the previous page
        },
        openPopup(video) {
            this.selectedVideo = video;
            this.isPopupDetail = true;
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        deleteVideo() {
            this.isPopupDelete = true;
        },
        shareVideo() {
            this.isPopupShareLink = true;
        },
        openSuccess() {
            this.isPopupSuccess = true;
            this.isPopupDelete = false;
        },
        GoToReview(companyId) {
            this.$router.push("Review?id=" + this.$route.query.id + "&companyId=" + companyId);
        },
        async GetDetailIndustries() {
    try {
        const response = await this.$API.get(this.$GetDetailIndustries + "?id=" + this.$route.query.id, {
            withCredentials: true,
        });

        console.log("API Response:", response.data); // Debugging

        if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
            this.detailIndustries = response.data;
        } else {
            console.warn("No valid data returned from API.");
            this.detailIndustries = []; // Ensure no empty objects cause rendering issues
        }
    } catch (error) {
        console.error("Error fetching user information:", error);
        this.detailIndustries = []; // Handle API errors gracefully
    }
}
    }
};
</script>

